// Imports
import React, { useEffect, useState } from "react"
import { ScrollContainer } from "react-indiana-drag-scroll"
import { AudianceCard } from "@molecules"
import { AudiancesCardWrapper } from "./audiances-card-wrapper"

export const AudiancesCardSection = ({ displayData }) => {
  const [cardCategories, setCardCategories] = useState([])

  const getUniqueCategories = (inputArray) => {
    const categories = []
    inputArray.forEach((item) => {
      const categoryIndex = categories.findIndex(
        (category) => category.category === item.category
      )
      if (categoryIndex === -1) {
        categories.push({ category: item.category, items: [item] })
      } else {
        categories[categoryIndex].items.push(item)
      }
    })
    return categories
  }

  useEffect(() => {
    if (displayData) setCardCategories(getUniqueCategories(displayData))
  }, [displayData])

  return (
    <div className="audiances-cards">
      <ScrollContainer>
        <React.Fragment>
          <AudianceCard mock first />
          <AudiancesCardWrapper cardCategories={cardCategories} />
          <AudianceCard mock />
        </React.Fragment>
      </ScrollContainer>
    </div>
  )
}
